import { createAppStore, ICreateAppStore } from 'affiny-core/modules';
import { Provider } from 'affiny-core/modules/store';
import { theme } from 'affiny-ui/src/theme';
import 'affiny-ui/src/icons.css';
import * as localForage from 'localforage';
import React from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { AppBootstrap } from './components/desktop/AppBootstrap';
import { rootSaga } from './redux/sagas';
import Routes from './routes/routes';
import { SToastContainer } from './services/ToasterDesktopStrategy';

const appStoreConf: ICreateAppStore = {
  rootSaga,
  storage: localForage,
  persitenceConfig: {
    whitelist: ['favorites'],
  },
};

const { store, persistedStore, PersistGate } = createAppStore(appStoreConf);

const GlobalStyle = createGlobalStyle`
  body[class*='modal-open-'] {
    overflow: hidden;
  }

  .slider, .slider-slide {
    outline: none;
  }

  ${theme.mediaQueries.md} {
    html {
      font-size: 12px;
    }
  }

  ${theme.mediaQueries.lg} {
    html {
      font-size: 16px;
    }
  }
`;

const App = () => (
  <>
    <GlobalStyle />
    <Provider store={store}>
      <PersistGate persistor={persistedStore}>
        <ThemeProvider theme={theme}>
          <AppBootstrap>
            <Routes />
            <SToastContainer />
          </AppBootstrap>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </>
);

export default App;
